import React from 'react';
import './WinnersList.css';
import { Helmet } from 'react-helmet-async';
const WinnersList = () => {
  return (
    <>
    <Helmet>
        <title>Nifty10 Winners List | Check Daily Contest Winners</title>
        <meta
          name="description"
          content="Learn how to check the list of Nifty10 contest winners directly on the app. View daily and past winners pool-wise and explore first prize winners."
        />
        {/* Optional Open Graph & Twitter tags for better social sharing */}
        <meta property="og:title" content="Nifty10 Winners List" />
        <meta
          property="og:description"
          content="Easily view Nifty10 contest winners pool-wise, check past winners, and track daily prize results."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.nifty10.com/winners" />
        <meta property="og:image" content="https://your-domain.com/images/winners-banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
    <section className='winners-list terms-conditions'>
      <h2 className='winners-list__heading'>
        Here is how you can check the list of Nifty10 winners on the app directly:
      </h2>
      <ol className='winners-list__steps'>
        <li className='winners-list__item'>
          <p><strong>Download the app: </strong>Go to your app store (Google Play Store or Apple App Store) and download the app onto your device.</p>
        </li>
        <li className='winners-list__item'>
          <p><strong>Sign Up & Login to your account:</strong> Open the app and follow the sign-up or login prompts to create your account or log into your existing account.</p>
        </li>
        <li className='winners-list__item'>
          <p><strong>Navigate to the 'Winners' section:</strong></p>
          <p>Look for a tab or menu option at the bottom of the app interface.</p>
          <p>Find and click on the tab labeled 'Winners'. This might be located in a navigation bar or menu depending on the app's design.</p>
        </li>
        <li className='winners-list__item'>
          <p><strong>Filter by pool and view contest winners:</strong></p>
          <p>Once you're on the 'Winners' page, there should be options to filter the winners by different contest pools or categories.</p>
          <p>Select the pool or category you're interested in (if applicable). Browse through the list or details provided to view the contest winners.</p>
        </li>
      </ol>

      <br />

      <h2 className='winners-list__heading'>
        What can you check on the app additionally?
      </h2>
      <ol className='winners-list__additional'>
        <li className='winners-list__additional-item'>
          Pool-wise winners. E.g. you can check who won Nifty10’s pool contest.
        </li>
        <li className='winners-list__additional-item'>
          Yes, you can even check the winner list by past games and not just the winners who won today or yesterday.
        </li>
        <li className='winners-list__additional-item'>
          You can filter by Pool wise contests and you’ll be able to see who all were the contest winners.
        </li>
        <li className='winners-list__additional-item'>
          Check the first prize winners from the Free Entry Pools.
        </li>
        <li className='winners-list__additional-item'>
          Moreover, you can even see the fantasy stock points and also the first prize winners.
        </li>
      </ol>
    </section></>
  );
};

export default WinnersList;
